import { render, staticRenderFns } from "./commonTabbar.vue?vue&type=template&id=5001b011&scoped=true&"
import script from "./commonTabbar.vue?vue&type=script&lang=js&"
export * from "./commonTabbar.vue?vue&type=script&lang=js&"
import style0 from "./commonTabbar.vue?vue&type=style&index=0&id=5001b011&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../viewport/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5001b011",
  null
  
)

export default component.exports